'use client'

import { CheckmarkIcon, CloseIcon } from '../../icons'
import React, { ReactNode } from 'react'
import { ChangeHandler } from 'react-hook-form'

export interface ToggleSwitchProps extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'> {
    label?: ReactNode
    id?: string
    form?: string
    name?: string
    value?: string | number
    labelBeforeSwitch?: boolean
    checked?: boolean
    disabled?: boolean
    readOnly?: boolean
    onChange?: ChangeHandler | ((value: unknown, checked: boolean) => void)
}

export const ToggleSwitch = ({
    label,
    labelBeforeSwitch = false,
    id,
    form,
    name,
    value,
    checked,
    disabled,
    readOnly,
    onChange,
    ...rest
}: ToggleSwitchProps) => {
    const labelClasses = `
            ${disabled ? 'toggle-switch--disabled' : ''}
            ${readOnly ? 'toggle-switch--readonly' : ''}
            ${labelBeforeSwitch ? 'flex flex-row-reverse justify-between gap-2' : ''}
        `

    return (
        <label htmlFor={id} className={`toggle-switch cursor-pointer ${labelClasses}`} data-cy="input-toggle-switch">
            <input
                {...rest}
                type="checkbox"
                id={id}
                form={form}
                name={name}
                value={value}
                disabled={disabled}
                className="toggle-switch__input"
                onChange={(e) => {
                    onChange && onChange(e, !checked)
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Space') {
                        onChange && onChange(e, !checked)
                    }
                }}
                checked={checked}
            />
            <div className="toggle-switch__pill">
                <div className="toggle-switch__pill-slider">{checked ? <CheckmarkIcon /> : <CloseIcon />}</div>
            </div>
            {label && <span className={!labelBeforeSwitch ? 'ml-2' : ''}>{label}</span>}
        </label>
    )
}
